import ReactCountryFlag from "react-country-flag"
import { Tooltip } from "antd"
import { useGetCountries } from "api/hooks/enum"
import "./CountryFlags.scss"

const CountryFlags = ({ countries }) => {
  const { data: countriesData } = useGetCountries()
  if (!countries || !countriesData) return null

  const iso2ToLabelMap = Object.values(countriesData).reduce((acc, country) => {
    if (country?.iso2) {
      acc[country.iso2] = country?.label
    }
    return acc
  }, {})

  const getCountryName = (countryCode) => {
    return iso2ToLabelMap[countryCode] || countryCode
  }

  const sortedCountries = [...countries].sort((a, b) => getCountryName(a).localeCompare(getCountryName(b)))

  const countriesToDisplay = sortedCountries.slice(0, 9)
  const countriesInTooltip = sortedCountries.slice(9)
  const restCountriesCount = countriesInTooltip.length

  return (
    <div className="language-to-flag-cell-renderer-container">
      <div className="display-country-container">
        {countriesToDisplay.map((country, index) => (
          <div
            className="country-container"
            key={country}
          >
            <ReactCountryFlag
              countryCode={country}
              svg
              style={{ width: "22px", height: "15px", borderRadius: "4px" }}
            />
            <span>
              {getCountryName(country)}

              {index === countriesToDisplay.length - 1 && restCountriesCount > 0 && (
                <span className="rest-country-container">
                  {restCountriesCount > 0 && (
                    <Tooltip
                      className="tool-tip"
                      title={countriesInTooltip.map(getCountryName).join(", ")}
                    >
                      <span className="rest-country-count">+{restCountriesCount}</span>
                    </Tooltip>
                  )}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CountryFlags
